import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getClass = createAsyncThunk(
  "Product/getClass",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/class`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            status: 1,
            is_restaurant: 1,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// =========================
export const getCategories = createAsyncThunk(
  "Product/getCategories",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/categories`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            status: 1,
            class_id: id,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// ============================
export const getCountries = createAsyncThunk(
  "Product/getCountries",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/countries`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            status: 1,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// ============================
export const getCity = createAsyncThunk(
  "Product/getCity",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/cities`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            status: 1,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// ============================

export const getZone = createAsyncThunk(
  "Product/getZone",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/zones`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            status: 1,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getProducts = createAsyncThunk(
  "Product/getProducts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/products`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getProductID = createAsyncThunk(
  "Product/getProductID",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/products/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addProducts = createAsyncThunk(
  "Product/addProducts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/products`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateProducts = createAsyncThunk(
  "Product/updateProducts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/products/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const deleteProducts = createAsyncThunk(
  "Product/deleteProducts",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/products${
          !Array.isArray(id) ? `/${id}` : ""
        }`,

        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          ...(Array.isArray(id) && { data: { ids: id } }),
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getOrders = createAsyncThunk(
  "Product/getOrders",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/orders`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            is_restaurant: 1,
            ...data,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getOrderID = createAsyncThunk(
  "Product/getOrderID",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/orders/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const updateOrders = createAsyncThunk(
  "Product/updateOrders",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/orders/${data.id}/update`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateOrdersStatus = createAsyncThunk(
  "Product/updateOrdersStatus",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.post(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/orders/${data.id}/status`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const ProductSlice = createSlice({
  name: "Product",
  initialState: {
    isProductLoading: false,
    error: null,
    ClassArray: null,
    CategoriesArray: null,
    CountriesArray: null,
    CityArray: null,
    ZonesArray: null,
    ProductsArray: null,
    PaginationProducts: null,
    OrderArray: null,
    ProductIDArray: null,
    OrderIDArray: null,
    OrderPaginationData: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCity.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getCity.fulfilled, (state, action) => {
        state.isProductLoading = false;
        state.CityArray = action.payload.data;
      })
      .addCase(getCity.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      .addCase(getCountries.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.isProductLoading = false;
        state.CountriesArray = action.payload.data;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.isProductLoading = false;
      })

      .addCase(getCategories.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isProductLoading = false;
        state.CategoriesArray = action.payload.data;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      .addCase(getClass.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getClass.fulfilled, (state, action) => {
        state.isProductLoading = false;
        state.ClassArray = action.payload.data;
      })
      .addCase(getClass.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      .addCase(getZone.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getZone.fulfilled, (state, action) => {
        state.isProductLoading = false;
        state.ZonesArray = action.payload.data;
      })
      .addCase(getZone.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // getProducts
      .addCase(getProducts.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        // if(action.payload)
        state.isProductLoading = false;

        if (action.meta.arg?.is_pagination === 1) {
          state.PaginationProducts = action.payload;
        } else if (action.meta.arg?.get === "all") {
          state.ProductsArray = action.payload.data;
        }
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // getProductID
      .addCase(getProductID.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getProductID.fulfilled, (state, action) => {
        state.isProductLoading = false;
        state.ProductIDArray = action.payload.data;
      })
      .addCase(getProductID.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // addProducts
      .addCase(addProducts.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(addProducts.fulfilled, (state, action) => {
        state.isProductLoading = false;
      })
      .addCase(addProducts.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // updateProducts
      .addCase(updateProducts.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(updateProducts.fulfilled, (state, action) => {
        state.isProductLoading = false;
      })
      .addCase(updateProducts.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // deleteProducts
      .addCase(deleteProducts.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(deleteProducts.fulfilled, (state, action) => {
        state.isProductLoading = false;
        const idsToDelete = Array.isArray(action.meta.arg)
          ? action.meta.arg
          : [action.meta.arg];
        if (state.ProductsArray) {
          state.ProductsArray = state.ProductsArray.filter(
            (ele) => !idsToDelete.includes(ele.id)
          );
        }

        if (state.PaginationProducts) {
          state.PaginationProducts.data = state?.PaginationProducts?.data?.filter(
            (ele) => !idsToDelete.includes(ele.id)
          );
        }
      })
      .addCase(deleteProducts.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // getOrders
      .addCase(getOrders.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.isProductLoading = false;

        if (action.meta.arg?.is_pagination === true) {
          state.OrderPaginationData = action.payload.data;
        } else {
          state.OrderArray = action.payload.data;
        }
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // getOrderID
      .addCase(getOrderID.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(getOrderID.fulfilled, (state, action) => {
        state.isProductLoading = false;
        state.OrderIDArray = action.payload.data;
      })
      .addCase(getOrderID.rejected, (state, action) => {
        state.isProductLoading = false;
      })
      // updateOrders
      .addCase(updateOrders.pending, (state) => {
        state.isProductLoading = true;
      })
      .addCase(updateOrders.fulfilled, (state, action) => {
        state.isProductLoading = false;
      })
      .addCase(updateOrders.rejected, (state, action) => {
        state.isProductLoading = false;
      });
  },
});

export default ProductSlice.reducer;
